import React, { createContext, useState } from "react";
import axios from "axios";
import Utils from "./../Utils";
import _ from "lodash";

const UserContext = createContext();

const UserProvider = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [stepData, setUCStepData] = useState({});

  const goLogin = ({ user, pass }, callback) => {
    axios
      .post(Utils.apiUrl("admin/login"), `&username=${user}&password=${pass}`, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data.success) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const goSSO = ({ name, email, marriott_emp }, callback) => {
    const body = {
      name,
      email,
      marriott_emp,
    };

    axios
      .post(Utils.apiUrl("frontend/auth/hotelrep-sso"), body, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data?.success) {
          Utils.setUserData({
            token: res.data.token,
            userData: res.data.userData,
          });
          setUserData(res.data.userData);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const phLogin = (data, callback) => {
    axios
      .post(Utils.apiUrl("frontend/auth"), data, Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        callback(res.data);
        if (res.data.success) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const logout = (callback) => {
    setUserData(false);
    Utils.setUserData(false);

    callback();
  };

  const getServerData = (url, pageInfo = false) => {
    return new Promise((resolve, reject) => {
      axios
        .get(Utils.apiUrl(url), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            resolve(pageInfo ? res.data : res.data.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };
  const setServerData = (url, data, method = "put", extraHeaders = {}) => {
    return new Promise((resolve, reject) => {
      axios[method](Utils.apiUrl(url), data, Utils.apiHeaders(extraHeaders))
        .then((res) => {
          if (res.data.success) {
            alert(res.data.id);
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        goLogin,
        logout,
        getServerData,
        setServerData,
        goSSO,
        phLogin
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };
